<template>
  <div
    :class="`grid grid-cols-${question.optionsColumnsNumber} gap-x-8 gap-y-12`"
    :data-qa="question.key"
  >
    <div
      v-for="option in question.options"
      :key="option.inputId"
      class="w-full"
    >
      <PickerWithImage
        v-if="question.isPickerWithImage"
        :data-qa="`${question.key}-${option.value}`"
        :description="option.description"
        :images-src="option.imagesSrc!"
        :label="option.label"
        :model-value="props.radioModel === option.value"
        @update:model-value="emit('answer', question.key, option.value)"
      />
      <RevPicker
        v-else
        :id="option.inputId"
        :alignment="option.description ? 'left' : 'center'"
        class="h-full w-full"
        :data-qa="`${question.key}-${option.value}`"
        :description="option.description"
        :label="option.label"
        :model-value="props.radioModel === option.value"
        @update:model-value="emit('answer', question.key, option.value)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevPicker } from '@ds/components/Picker'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import PickerWithImage from './PickerWithImage.vue'

const props = defineProps<{
  question: RenderQuestion
  radioModel: string | false
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string): void
}>()
</script>
